import { actionChannel, take } from "@redux-saga/core/effects";
import { Action } from "redux";
import { Buffer, buffers, Channel } from "redux-saga";
import { fork, put, select } from "redux-saga/effects";
import { SaveAnnotation, updateFakeAnnotation } from "../actions";
import { imageAnnotationApi } from "../api";
import { ActionTypes } from "../const/ActionTypes";
import { getCurrentAttachmentId, getImagesEntities } from "../selectors";

export function* watchSaveAnnotation() {
    yield fork(saveAnnotation);
}

function* saveAnnotation() {
    const buffer: Buffer<Action> = buffers.expanding(1);
    const channel: Channel<any> = yield actionChannel([ActionTypes.SAVE_ANNOTATION], buffer);

    try {
        while (true) {
            const action: SaveAnnotation = yield take(channel);
            const attachmentId: number = yield select(state => getCurrentAttachmentId(state));

            if (action.type === ActionTypes.SAVE_ANNOTATION) {
                const { annotationItem, messageInfo, ...bodyData } = action.data;
                const annotationId: number = yield imageAnnotationApi.saveAnnotation({ ...bodyData, attachmentId });

                if (action.callback) {
                    const file: unknown = yield select(state => getImagesEntities(state)[attachmentId].file);

                    yield action.callback(annotationId, attachmentId, file);
                }

                yield put(updateFakeAnnotation(attachmentId, annotationId, annotationItem, messageInfo));
            }
        }
    } finally {
        channel.close();
    }
}
